export default "__VITE_ASSET___fNa0i1X__"